import { Navigate, Route } from "react-router-dom";

import { List as ListColors } from "../../Colors/components";
import { List as ListTeams } from "../../Teams/components";
import { List as ListUsers, NewUSer } from "../../Users/components";

import manufactureRoutes from "../../Manufacture/routes";
import productCategoryRoutes from "../../ProductCategory/routes";

const adminRoutes = [
    <Route index element={<Navigate to="general" replace />} key={"admin:index"} />,
    <Route path="general" element={<ListColors />} key={"list"} />,
    <Route path="manufacture" key={"manufacture"}>
        {manufactureRoutes}
    </Route>,
    <Route path="product-category" key={"product-category"}>
        {productCategoryRoutes}
    </Route>,
    <Route path="suppliers" element={<div>test</div>} key={"list:details"} />,
    <Route path="teams" element={<ListTeams />} key={"new"} />,
    <Route path="users" element={<ListUsers />} key={"new"} />,
    <Route path="users/new" element={<NewUSer />} />,
];
export default adminRoutes;
